<template>
    <div>
        <div class="row">
            <div class="col-sm-1">
                <div class="form-group">
                    <label class="label-control blue">{{$t('year')}}</label>
                    <div>
                        <select class="form-control form-control-sm" v-model="query.Year" @change="toList">
                            <option v-for="ret in $years()" :value="ret" :key="ret">{{ret}}</option>
                        </select>
                    </div>
                </div>
            </div>
            <div class="col-sm-1">
                <div class="form-group">
                    <label class="label-control blue">{{$t('month')}}</label>
                    <div>
                        <select class="form-control form-control-sm" v-model="query.Month" @change="toList">
                            <option v-for="n in 12" :value="n" :key="n">{{$t('month_' + n)}}</option>
                        </select>
                    </div>
                </div>
            </div>
        </div>
        <div class="row">
            <div class="col-sm-12">
                <table class="table table-bordered table-sm table-striped no-bor">
                    <thead>
                        <tr>
                            <th style="width: 50px;" class="text-center">{{$t('no')}}</th>
                            <th>{{$t('code')}}</th>
                            <th>{{$t('date')}}</th>
                            <th class="sorting">{{$t('customer')}}</th>
                            <th>{{$t('sale_reputation')}}</th>
                            <th>{{$t('delivery_to_branch')}}</th>
                            <th>{{$t('ref_num')}}</th>
                            <th style="width: 150px;">{{$t('total_amount')}}</th>
                            <th style="width: 150px;">{{$t('discount')}}</th>
                            <th class="text-right" style="width: 150px;">{{$t('paid_amount')}}</th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-for="(ret, index) in records" :key="index">
                            <td class="text-center">{{index+1}}</td>
                            <td>{{ret.Num}}</td>
                            <td>{{$format(ret.Date, 'DD/MM/YYYY')}}</td>
                            <td>{{ret.CustomerName}}</td>
                            <td>{{ret.EmployeeName}}</td>
                            <td>{{ret.BranchName}}</td>
                            <td>{{ret.RefNum}}</td>
                            <td class="text-right">{{$money(ret.TotalAmount)}}</td>
                            <td class="text-right">{{$money(ret.Discount)}}</td>
                            <td class="text-right">{{$money(ret.PaidAmount)}}</td>
                        </tr>
                    </tbody>
                    <tfoot>
                        <tr>
                            <th colspan="9" class="text-right">{{$t('total')}}</th>
                            <th class="text-right">{{$money(totalAmount)}}</th>
                        </tr>
                    </tfoot>
                </table>
            </div>
        </div>
    </div>
</template>
<script>
    export default {
        data: function(){
            return {
                query:{
                    Year: new Date().getFullYear(),
                    Month: new Date().getMonth() + 1
                },
                records:[]
            }
        },
        created: function(){
            this.toList();
        },
        methods: {
            toList(){
                var loading = this.$loading.show();
                    this.$api().post('report/expense/returns', this.query).then(res => {
                    if(this.$isValid(res)){
                        this.records = res.data.Json.Exchanges;
                        this.$emit('change', 4, this.query);
                    }
                }).finally(() => { loading.hide(); });
            }
        },
        computed: {
            totalAmount(){
                let total = 0;
                this.records.map(el=>{
                    total += el.PaidAmount;
                });
                return total;
            }
        }
    }
</script>